<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase v-bind="$attrs">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.7784 10.0323L11.0304 15.7803C10.8898 15.9209 10.699 15.9999 10.5001 15.9999C10.3012 15.9999 10.1104 15.9209 9.96977 15.7803L7.2243 13.0347C6.93141 12.7418 6.93142 12.267 7.22431 11.9741C7.51721 11.6812 7.99208 11.6812 8.28497 11.9741L10.5001 14.1893L15.7178 8.97162C16.0107 8.67873 16.4855 8.67873 16.7784 8.97162C17.0713 9.26452 17.0713 9.73939 16.7784 10.0323Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
